import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// ── Startup environment check ─────────────────────────────────────────────────
// Validate the Supabase URL points to the expected project for this environment.
const EXPECTED_PROJECT_REF = "bbygnqkxijbplzuhktfm";
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;

if (!supabaseUrl) {
  console.error(
    "[CRITICAL] VITE_SUPABASE_URL is not set. The app cannot connect to the backend."
  );
} else {
  try {
    const hostname = new URL(supabaseUrl).hostname;
    const projectRef = hostname.split(".")[0];
    if (projectRef !== EXPECTED_PROJECT_REF) {
      console.error(
        `[CRITICAL] Supabase project mismatch! ` +
        `Got: "${projectRef}", Expected: "${EXPECTED_PROJECT_REF}". ` +
        `Check your environment variables — production may be pointing at the wrong project.`
      );
    } else {
      console.info(`[boot] Supabase project ref verified: ${projectRef}`);
    }
  } catch {
    console.error("[CRITICAL] VITE_SUPABASE_URL is not a valid URL:", supabaseUrl);
  }
}
// ─────────────────────────────────────────────────────────────────────────────

createRoot(document.getElementById("root")!).render(<App />);
